import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/PolicySections/PolicySections.js
const PolicySections = createSectionForm({
  icon: "file-list-3-line",
  title: "Policy Sections",
  fields: [
    { name: "title", label: "Page Title" },
    { name: "show_list_markers", label: "Show Bullets / Numbers in Lists", type: "switch" },
    { name: "large_mobile_spacing", label: "Larger Spacing on Mobile", type: "switch" },
    { name: "intro", label: "Intro", type: "richtext" },
    {
      name: "items",
      label: "Sections",
      type: "list",
      itemLabel: "Section",
      fields: [
        { name: "heading", label: "Heading" },
        { name: "content", label: "Content", type: "richtext", height: 180 },
      ],
    },
  ],
});

export default PolicySections;
